module.exports = __webpack_public_path__ + "img/maths-textbook-active.70f1d6ee.png";